import {AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import {BehaviorSubject, Observable, of, Subject, Subscription} from 'rxjs';
import { ColumnMode, DatatableComponent, SelectionType } from '@swimlane/ngx-datatable';
import {QueryParamsModel} from "../../../../core/_base/crud";
import {debounceTime, filter, switchMap, take} from "rxjs/operators";
// import { QueryParamsModel } from '../../../../core/_base/crud';
import * as _ from 'lodash'

export interface BasicColumn{
  name: string; //nombre de la columna en BD, se usa para ordenar, debe ser referente a la tabla origen
  alias: string; //nombre de la columna en la tabla, debe ser util al usuario
  transformFcn?(row: any):any; //Funcion que transforma la fila y retorna el valor que finalmente se muestra ( es opcional )
  isDate?: boolean; //En caso de ser true, el valor es transformado en texto fecha
  width?: number;
};
export interface BasicTableInterface{
  columnList: BasicColumn[];
  rowsObs: BehaviorSubject<any[]>;
  sortObs: BehaviorSubject<any>;
  totalCount: number;
  lastQuery?: QueryParamsModel;
  detailTemplate?: TemplateRef<any>;
  onDetailsExpansion?(row: any):void;
  getActionBtnList():any[];
  getRows(pageInfo: {page: number, pageSize: number}): any;
  fetchData(queryParams: QueryParamsModel): any;
  onSort(event: any): any;
  onClickActionBtn(event: any): any;
}

//Tabla de datos locales
export class BasicTable implements BasicTableInterface{
  columnList: BasicColumn[] = [];
  rowsObs: BehaviorSubject<any> = new BehaviorSubject(null);
  sortObs: BehaviorSubject<any> = new BehaviorSubject(null);
  totalCount: number = 0;
  lastQuery!: QueryParamsModel;
  detailTemplate!: TemplateRef<any>;
  data: any[] = [];
  shouldHideActionBtn: (btnText: string, row: any)=>boolean = (btnText: string, row: any) => false;

  constructor(columnList: BasicColumn[]){
    this.columnList = columnList;
    this.lastQuery = this.buildQueryParams(1, 5);
  }

  setDetailTemplate(detailTemplate: TemplateRef<any>){
    this.detailTemplate = detailTemplate;
  }

  getActionBtnList(): any[] {
    return [];
  }
  getRows(pageInfo: { page: number; pageSize: number; }) {
    const queryParams = this.buildQueryParams(pageInfo.page, pageInfo.pageSize);
    this.lastQuery = queryParams;
    this.fetchData(queryParams);
  }
  fetchData(queryParams: QueryParamsModel){
    let rows = this.data;
    if(queryParams.sortOrder && queryParams.sortField){
      rows = _.orderBy(rows, [queryParams.sortField], [queryParams.sortField.toLowerCase() as "asc" | "desc"]);
    }
    if(queryParams.pageSize != undefined && queryParams.pageNumber != undefined){
      const chunks = _.chunk(rows, queryParams.pageSize);
      rows = chunks[queryParams.pageNumber];
    }
    this.totalCount = this.data.length;
    // this.cdr.detectChanges();
    this.rowsObs.next(rows);
  }
  refreshTable(){
    this.fetchData(this.lastQuery);
  }
  setData(rows: any[]){
    this.data = rows;
    this.refreshTable();
  }
  onSort(event: any) {
    //console.log("sort"); console.dir(event);
    const sort = event.sorts && event.sorts.length > 0 ? event.sorts[0] : undefined;
    if (sort != undefined) {
      this.sortObs.next({ sortOrder: sort.dir, sortField: sort.prop });
    }
  }
  //Eventos al presionar un boton de accion de alguna fila de la tabla
  onClickActionBtn(event: any) {
    //console.log("click action btn: "); console.dir(event);
    // this.clickActionBtnEvent.emit(event);
    const btn = event.button;
    const row = event.row;

    // if (this.enableCommonActions.delete && btn.text == this.deleteBtn.text) {
    //     this.selectedRow = row;
    //     this.deleteModal.display = true;
    // }else if (this.enableCommonActions.edit && btn.text == this.editBtn.text) {
    //     this.selectedRow = row;
    //     this.mode = "edit";
    //     this.formModal.title = this.formModal.title.replace('Nuevo', 'Modificar');
    //     this.formModal.display = true;
    // }
  }

  buildQueryParams(page, pageSize){
    return new QueryParamsModel(
      this.lastQuery ? this.lastQuery.filter : {},
      this.lastQuery?.sortOrder,
      this.lastQuery?.sortField,
      page - 1,
      pageSize,
      undefined
    );
  }

  onDetailsExpansion(row: any){

  }
}

//Tabla con paginacion bd api
export class PageTable extends BasicTable{

  subscriptions: Subscription[] = [];
  getPage: (queryParams: QueryParamsModel) => Observable<{ totalCount: number; items: any[]; }>;
  dataObs: BehaviorSubject<any> = new BehaviorSubject(null);

  constructor(columnList: BasicColumn[], getPage: (queryParams: QueryParamsModel) => Observable<{totalCount: number, items: any[]}>){
    super(columnList);
    this.getPage = getPage;
  }

  listenEvents(){
    this.subscriptions.push(
      this.rowsObs.pipe(
        filter(rows=>rows && rows.length > 0),
        take(1),
        switchMap(()=>this.sortObs),
        filter(sortParams => sortParams != undefined),
        debounceTime(250)
      ).subscribe(sortParams => {
        this.lastQuery.sortField = sortParams.sortField;
        this.lastQuery.sortOrder = sortParams.sortOrder;
        this.fetchData(this.lastQuery);
      })
    );
  }

  override fetchData(queryParams: QueryParamsModel){
    this.lastQuery = queryParams;
    this.subscriptions.push(
      of(null).pipe(
        switchMap(()=>this.getPage(queryParams))
      ).subscribe(resp=>{
        console.log("resp"); console.dir(resp);
        this.totalCount = resp.totalCount;
        // this.cdr.detectChanges();
        this.rowsObs.next(resp.items);
        this.dataObs.next(resp);
      })
    );
  }

  destroy(){
    this.subscriptions.forEach(sub=>sub.unsubscribe());
  }
}

@Component({
  selector: 'app-basic-table',
  templateUrl: './basic-table.component.html',
  styleUrls: ['./basic-table.component.scss',

  ]
})
export class BasicTableComponent implements OnInit, OnDestroy, AfterViewInit {

  public ColumnMode = ColumnMode;
  @ViewChild(DatatableComponent) table?: DatatableComponent;
  tablestyle = 'bootstrap';
  rows = [];
  fullScreenRow = [];
  loadingIndicator = true;
  reorderable = true;

  isLoading: boolean;
  page: any;

  private subscriptions: Subscription[] = [];

  @Input() columnList:{alias:string, name:string, isDate?:boolean, transfromFcn?:any, dtype?:string, width?: number}[] = [];
  @Input() actionBtnList: any[] = [];
  @Input() rowsObs: Subject <any[]>;
  @Input() limit: number = 6;
  @Input() totalCount: number = 6;
  @Input() shouldHideActionBtn = null;
  @Input() availableActions: {edit: boolean, delete: boolean} = {edit: true, delete: true};
  @Input() hideActions: boolean = false;
  @Input() scrollbarH: boolean = false;
  @Output() getRowsEvent = new EventEmitter<any>()
  @Output() clickActionBtnEvent = new EventEmitter<any>();
  @Output() onSort = new EventEmitter<any>();
  @Output() onClick = new EventEmitter<any>();
  pageList: number[] = [];
  currentPage: number = 1;
  lastPage:number = 1;
  currentNavPag: number = 1;
  @Output() rowClick = new EventEmitter<{row: any, column: any}>();


  constructor(
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnDestroy(): void {
      this.subscriptions.forEach(sub=>sub.unsubscribe());
  }

  ngOnInit() {
    console.log('this.currentNavPag init >>>', this.currentNavPag);
  }

  ngAfterViewInit(){
    this.subscriptions.push(
        this.rowsObs.subscribe(rows=>{
          console.log("rows: ");
          console.dir(rows);
            this.rows = rows;
            this.refreshPagination();
            this.cdr.detectChanges();
            this.isLoading = false;
        })
    )
    this.requestItems(this.currentPage);
  }

  handleScroll(){

  }

  recalculate(): void {
    if (this.table) this.table.recalculate();
  }

  getNotHiddenActionBtnList(row){
    if(this.shouldHideActionBtn==null || this.shouldHideActionBtn == undefined){
      return this.actionBtnList;
    }
    return this.actionBtnList.filter(btn=>!this.shouldHideActionBtn(btn.text, row));
  }

  refreshPagination(){
    this.pageList = [];
    let startPage = this.currentPage-3;
    if(startPage <= 0) startPage = 1;
    let endPage = startPage + 6;
    if(endPage > this.totalCount/this.limit) endPage = Math.ceil(this.totalCount/this.limit)

    console.log(`start page: ${startPage} | end page: ${endPage} | total: ${this.totalCount} | limit: ${this.limit}`);
    for(let i = startPage;i<=endPage;i+=1){
      this.pageList.push(i);
    }

    this.lastPage = Math.ceil(this.totalCount/this.limit);
  }

  requestItems(selectedPage){
    this.isLoading = true;
    this.clearTable();
    const request = {page: selectedPage, pageSize: this.limit};
    console.log("request: ");console.dir(request);
    this.getRowsEvent.emit(request);
    this.currentPage = selectedPage;
    this.currentNavPag = selectedPage;
    this.refreshPagination();
  }

  /**
   * Populate the table with new data based on the page number
   * @param page The page to select
   */
  // setPage(pageInfo) {
  //   this.loadItems(pageInfo);
  // }

  onClickActionBtn(row, action){
    console.dir({action, row})
    this.clickActionBtnEvent.emit({
      row: row,
      action: action
    });
  }

  clickPaginationBtn(selectedPage){
    console.log('pagination button clicked');
    console.dir(selectedPage);
    if(selectedPage == 'next'){
      this.requestItems(this.currentPage+1);
    }else if(selectedPage == 'prev'){
      this.requestItems(this.currentPage-1);
    }else{
      this.requestItems(selectedPage);
    }
  }

  sortEvent(event){
    this.isLoading = true;
    this.clearTable();
    this.onSort.emit(event);
  }

  pageEvent(event){
    const offset = event.offset; // == pagenumber
    this.requestItems(offset+1);
  }

  clearTable(){
    this.rows = [];
    this.cdr.detectChanges();
  }
/*  Object { type: "click", event: click, row: {…}, group: undefined, rowHeight: 58, column: {…}, value: "2024-12-10T10:57:13.557Z", cellElement: datatable-body-cell.datatable-body-cell.sort-active.ng-star-inserted.active, cellIndex: 0, rowElement: datatable-body-row.datatable-body-row.datatable-row-even.ng-star-inserted
}
cellElement: <datatable-body-cell class="datatable-body-cell sort-active ng-star-inserted" tabindex="-1" ng-reflect-row="[object Object]" ng-reflect-expanded="false" ng-reflect-is-selected="false" ng-reflect-row-index="0" ng-reflect-column="[object Object]" ng-reflect-row-height="58" style="width: 140.4px; height: 58px;">
cellIndex: 0
column: Object { isFirstChange: false, __ngContext__: 96, name: "Fecha", … }
event: click { target: div.ng-star-inserted
  , buttons: 0, clientX: 311, … }
group: undefined
row: Object { id: 223192, alarm_message: "Alarma en PARQUE SOLAR DON HUMBERTO POL N1, favor revisar: ZONA5_POL1 Se ha traspaspaso en zona  ACTIVACION", alarm_value: "1", … }
rowElement: <datatable-body-row class="datatable-body-row datat…w-even ng-star-inserted" tabindex="-1" ng-reflect-is-selected="false" ng-reflect-inner-width="702" ng-reflect-offset-x="0" ng-reflect-columns="[object Object],[object Object" ng-reflect-row-height="58" ng-reflect-row="[object Object]" ng-reflect-row-index="0" ng-reflect-expanded="false" style="width: 702px; height: 58px;">
rowHeight: 58
type: "click"
value: "2024-12-10T10:57:13.557Z"*/
  mouseEvent(event: any) {
    if(event.type === 'click') {
      /*console.log("row click ", event)
      try {*/
        this.rowClick.emit({
          column: event.column,
          row: event.row
        })
      /*}catch(err){
        console.log("ERROR ROW CLICK ", err)
      }finally{
        console.log("EVENT ROW CLICK EMITED")
      }*/
    }
  }
}
